(function () {
  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }

    callback();
  }

  onReady(function () {
    if (!window.jQuery || !window.jQuery.fn.slick) return;

    function initSlider(slider) {
      var $slider = window.jQuery(slider);

      if ($slider.hasClass('slick-initialized')) return;

      $slider.slick({
        arrows: true,
        draggable: true,
        infinite: true,
        swipe: true,
        touchMove: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        prevArrow:
          '<button class="featured-slider__arrow featured-slider__arrow--prev" type="button" aria-label="Previous products"><svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path d="M15.5 4.5 8 12l7.5 7.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow:
          '<button class="featured-slider__arrow featured-slider__arrow--next" type="button" aria-label="Next products"><svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path d="m8.5 4.5 7.5 7.5-7.5 7.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              centerMode: true,
              centerPadding: '10%',
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }

    var sliders = document.querySelectorAll('.slick_product_slider');

    if (!('IntersectionObserver' in window)) {
      sliders.forEach(initSlider);
      return;
    }

    var sliderObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          observer.unobserve(entry.target);
          initSlider(entry.target);
        });
      },
      { rootMargin: '600px 0px' }
    );

    sliders.forEach(function (slider) {
      sliderObserver.observe(slider);
    });
  });
})();
